import React from 'react';
import PropTypes from 'prop-types';
import MitigationTable from '../../MitigationTable';
import SafetyRequirements from './SafetyRequirements';
import PerformanceTargets from './PerformanceTargets';
import MitigationsImplementated from './MitigationsImplementated';

function Mitigation(props) {
  const { srm } = props;
  console.log('logMit', srm);
  const mitigations = [
    {
      name: 'Safety Requirements',
      component:
  <SafetyRequirements srm={srm} />,
    },
    { name: 'Mitigations Implementated', component: <MitigationsImplementated srm={srm} /> },
    { name: 'Performance Targets', component: <PerformanceTargets srm={srm} /> },
  ];
  return (
    <div className="w-full mx-auto">
      {mitigations.map((mitigation) => (
        <div key={mitigation.name} className="rounded-md shadow-md mb-10">
          <MitigationTable
            title={mitigation.name}
            content={mitigation.component}
            srm={srm}
          />
        </div>
      ))}
    </div>
  );
}
export default Mitigation;
// Define PropTypes
Mitigation.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  srm: PropTypes.object.isRequired,
};
